import { render } from "./underwriter.vue?vue&type=template&id=60bfe4ff&lang=html"
import script from "./underwriter.vue?vue&type=script&lang=js"
export * from "./underwriter.vue?vue&type=script&lang=js"

import "./underwriter.vue?vue&type=style&index=0&id=60bfe4ff&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__